





















































import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import ArrowRightInfoIcon from '@/components/icons/ArrowRightInfo.vue';
import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import ProgramStatusTag from '@/componentsV2/atoms/ProgramStatusTag/ProgramStatusTag.vue';
import PercentIcon from '@/components/icons/Percent.vue';

@Component({
  components: {
    Typography,
    GhostButton,
    ArrowRightInfoIcon,
    FilterTag,
    ProgramStatusTag,
    PercentIcon
  }
})
export default class EmailAutomationItem extends Vue {
  @Prop() item!: any;

  get tPrefix() {
    return 'emailAutomation';
  }

  get title() {
    return this.$t(`${this.tPrefix}.email.title`) as string;
  }

  get invited() {
    return this.item.invited;
  }

  get members() {
    return this.item.converted;
  }

  get conversionRate() {
    return `${((this.item.conversionRate || 0) * 100).toFixed(0)}%`;
  }

  goToEmailDetail() {
    this.$router.push('/activation-emails/detail');
  }
}
